import { Action } from '@ngrx/store';
import { IConnectorValidation } from '@shared/services/api/dashboard/integrations-service/integrations-model';
import { IGetUserProvisioning, IUserProvisioning } from '@shared/services/api/dashboard/user-provisionings-service/user-provsionings-model';
import { IPermission } from '@shared/services/api/legacy/settings-service/setting-model';
import { ITenant } from '@shared/services/api/legacy/users-service/user-model';

export enum AppActionTypes {
    CLEAR_PROFILE = '[App] CLEAR_PROFILE',
    RETRIEVE_PROFILE_PENDING = '[App] RETRIEVE_PROFILE_PENDING',
    RETRIEVE_CRMS_PENDING = '[App] RETRIEVE_CRMS_PENDING',
    RETRIEVE_TENANTSETTINGS_PENDING = '[App] RETRIEVE_TENANTSETTINGS_PENDING',
    PROFILE_RETRIEVED = '[App] PROFILE_RETRIEVED',
    CRMS_RETRIEVED = '[App] CRMS_RETRIEVED',
    TENANTSETTINGS_RETRIEVED = '[App] TENANTSETTINGS_RETRIEVED',
    PROVISIONING_RETRIEVED = '[App] PROV_RETRIEVED',
    RETRIEVE_PROVISIONING_PENDING = '[App] RETRIEVE_PROV_PENDING',
}

export class ClearProfile implements Action {
    public readonly type = AppActionTypes.CLEAR_PROFILE;
}

export class RetrievePrincipalProfilePending implements Action {
    public readonly type = AppActionTypes.RETRIEVE_PROFILE_PENDING;
}

export class RetrieveCrmsPending implements Action {
    public readonly type = AppActionTypes.RETRIEVE_CRMS_PENDING;
}

export class RetrieveTenantSettingsPending implements Action {
    public readonly type = AppActionTypes.RETRIEVE_TENANTSETTINGS_PENDING;
}

export class ProvisioningRetrieved implements Action {
    constructor(public payload: IProvisioningPayload) { }

    public readonly type = AppActionTypes.PROVISIONING_RETRIEVED;
}

export class RetrieveProvisioningPending implements Action {
    public readonly type = AppActionTypes.RETRIEVE_PROVISIONING_PENDING;
}

export interface IProfileRetrievedPayload {
    id: string;
    name: string;
    firstName: string;
    languageId: string;
    pictureUrl: string;
    jobTitle: string;
    aadRemoteId: string;
    tenants: ITenant[];
    localeId: string;
    isSupport: boolean;
}

export interface ICrmsPayload {
    crms: IConnectorValidation[];
}

export interface IProvisioningPayload {
    provisioning: IGetUserProvisioning;
}

export interface ITenantSettingsPayload {
    setttings: IPermission;
}


export class ProfileRetrieved implements Action {
    constructor(public payload: IProfileRetrievedPayload) { }

    public readonly type = AppActionTypes.PROFILE_RETRIEVED;
}

export class CrmsRetrieved implements Action {
    constructor(public payload: ICrmsPayload) { }

    public readonly type = AppActionTypes.CRMS_RETRIEVED;
}

export class TenantSettingsRetrieved implements Action {
    constructor(public payload: ITenantSettingsPayload) { }

    public readonly type = AppActionTypes.TENANTSETTINGS_RETRIEVED;
}

export type AppActions =
    | ClearProfile
    | RetrievePrincipalProfilePending
    | ProfileRetrieved
    | CrmsRetrieved
    | RetrieveTenantSettingsPending
    | TenantSettingsRetrieved
    | ProvisioningRetrieved;
